@import '../../global/style/nano-theme/components';
@import '../../global/style/nano-theme/layers';

:host {
  /**
   * @prop --base-color-rgb: default #{$progress-indicator-color-rgb}
   * @prop --indicator-color: default var(--nano-indicator-color, rgba(var(--base-color-rgb), 1));
   * @prop --track-color: default var(--nano-track-color, rgba(var(--base-color-rgb), 0.2));
   * @prop --spinner-scale: optional scaling of the spinner. default contextual font-size
   * @prop --overlay-color: #{$layer-overlay-light};
   */

  display: inline-block;

  // --spinner-scale: 5em;
  --base-color-rgb: #{$progress-indicator-color-rgb};
  --indicator-color: var(--nano-indicator-color, rgba(var(--base-color-rgb), 1));
  --track-color: var(--nano-track-color, rgba(var(--base-color-rgb), 0.2));
  --overlay-color: #{$layer-overlay-light};
}

.spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  :host([overlay]:not([overlay='false'])) & {
    position: absolute;
    inset: 0;

    .spinner__loader,
    .spinner__text {
      z-index: 1;
    }
  }

  &__overlay {
    background: var(--overlay-color);
    position: absolute;
    inset: 0;
    z-index: 0;
    backdrop-filter: blur(#{$layer-overlay-blur});
  }

  &__loader {
    font-size: var(--spinner-scale, 1em);
  }

  &__spin {
    display: block;
    margin: auto;
    inline-size: 1em;
    block-size: 1em;
    border-radius: 50%;
    border: solid 0.1em var(--track-color);
    border-block-start-color: var(--indicator-color);
    border-inline-end-color: var(--indicator-color);
    border-inline-start-color: var(--indicator-color);
    animation: 1s linear infinite spin;
  }

  &__dna {
    font-size: 0.2286em;
    display: flex;
  }

  &__dnatrack {
    position: relative;
    padding-block: 0;
    padding-inline: 0.625em;
    block-size: 4.375em;
    inline-size: 0.625em;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      inset-block-start: 1.875em;
      inset-inline-start: 50%;
      transform: translateX(-50%) translateZ(0);
      inline-size: 0.0625em;
      inline-size: #{'max(.0625em, 1px)'};
      block-size: 0.625em;
      background: var(--track-color);
      animation: flex 1.5s linear infinite;
      transform-origin: center center;
    }

    &--2::before {
      animation: flex 1.5s -1.3s linear infinite;
    }

    &--3::before {
      animation: flex 1.5s -1.1s linear infinite;
    }

    &--4::before {
      animation: flex 1.5s -0.9s linear infinite;
    }

    &--5::before {
      animation: flex 1.5s -0.75s linear infinite;
    }
  }

  &__dnadot {
    position: absolute;
    inline-size: 0.5em;
    block-size: 0.5em;
    border-radius: 50% 50%;
    background: var(--indicator-color);
    animation: rotate 1.5s linear infinite;
    transform-origin: center center;
    inset-inline-start: 50%;
    transform: translateX(-50%) translateZ(0) translateY(0);

    &--2 {
      animation: rotate 1.5s -0.75s linear infinite;
    }

    &--3 {
      animation: rotate 1.5s -1.3s linear infinite;
    }

    &--4 {
      animation: rotate 1.5s -0.55s linear infinite;
    }

    &--5 {
      animation: rotate 1.5s -1.1s linear infinite;
    }

    &--6 {
      animation: rotate 1.5s -0.35s linear infinite;
    }

    &--7 {
      animation: rotate 1.5s -0.9s linear infinite;
    }

    &--8 {
      animation: rotate 1.5s -0.15s linear infinite;
    }

    &--9 {
      animation: rotate 1.5s -0.75s linear infinite;
    }

    &--10 {
      animation: rotate 1.5s 0s linear infinite;
    }
  }

  &__text {
    text-align: center;
    position: relative;
    margin-block-start: 0.5em;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes rotate {
    0%,
    100% {
      transform: translateX(-50%) translateY(0) scale(1);
    }

    25% {
      transform: translateX(-50%) translateY(1.875em) scale(2);
    }

    50% {
      transform: translateX(-50%) translateY(3.75em) scale(1);
    }

    75% {
      transform: translateX(-50%) translateY(1.875em) scale(0.3);
    }
  }

  @keyframes flex {
    0%,
    100% {
      transform: translateX(-50%) scaleY(5);
    }

    25% {
      transform: translateX(-50%) scaleY(1);
    }

    50% {
      transform: translateX(-50%) scaleY(5);
    }

    75% {
      transform: translateX(-50%) scaleY(1);
    }
  }
}
